import React, { PropTypes } from "react";

class Prompt extends React.Component {
  static contextTypes = {
    history: PropTypes.object
  };

  static defaultProps = {
    when: true
  };

  constructor() {
    super();

    this.state = {
      modal: false
    };
  }

  block() {
    if (!this.teardownPrompt)
      this.teardownPrompt = this.context.history.block(this.props.message);
  }

  unblock() {
    if (this.teardownPrompt) {
      this.teardownPrompt();
      this.teardownPrompt = null;
    }
  }

  componentWillMount() {
    if (this.props.when) this.block();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      this.block();
    } else {
      this.unblock();
    }
  }

  componentWillUnmount() {
    this.unblock();
  }

  render() {
    return null;
  }
}

export default Prompt;



// WEBPACK FOOTER //
// ./src/browser/components/NavigationPrompt/NavigationPrompt.js